import React from 'react'
import {Table, TableBody, TableHead, TableRow, withStyles} from '@material-ui/core';
import styles from './styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames'
import {
  Pagination,
  Portlet,
  PortletContent,
  TableCellWithConfig,
  TableSettings,
  TextPlaceholderWrapper
} from '../../index'
import useTablePagination from '../../../hooks/useTablePagination';
import useTableConfig from '../../../hooks/useTableConfig';
import DefaultConfig from './config';
import {getTableKey} from '../../../services/util/tableConfigHelper';
import {TableKind} from '../../../services/enums/TableKind';
import {displayModes} from '../../../services/enums/displayModes';
import Columns from './columns';

function SpecialDeliveryDaysTable(props) {

  const {classes, className, specialDeliveryDays, deleteSpecialDeliveryDay, t, displayMode} = props;

  const {
    config,
    columnConfigs,
    updateConfig
  } = useTableConfig(
    DefaultConfig,
    displayMode,
    getTableKey(TableKind.SpecialDeliveryDayTable, displayMode),
  )

  const {paginationProps, pagedObjects} = useTablePagination(specialDeliveryDays);

  const rootClassName = classNames(classes.root, className);

  return (
    <TextPlaceholderWrapper
      active={!specialDeliveryDays?.length}
      text={t('noSpecialDeliveryDaysFound')}
    >
      <Portlet className={rootClassName}>
        <PortletContent noPadding>
          <TableSettings
            columns={Columns}
            tableConfig={config}
            updateConfig={updateConfig}
          />
          <Table size="medium">
            <TableHead>
              <TableRow>
                {columnConfigs.map(columnConfig => (
                  <TableCellWithConfig
                    config={columnConfig}
                    key={columnConfig.order}
                  >
                    {Columns[columnConfig.columnName].header({t})}
                  </TableCellWithConfig>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {pagedObjects.map((specialDeliveryDay, index) => (
                <TableRow
                  className={classNames(classes.tableRow, 'cursorPointer')}
                  hover
                  key={index}
                >
                  {columnConfigs.map(columnConfig => (
                    <TableCellWithConfig
                      className={classes.tableCell}
                      config={columnConfig}
                      key={columnConfig.order}
                    >
                      {Columns[columnConfig.columnName].body({
                        specialDeliveryDay, classes, t, deleteSpecialDeliveryDay
                      })}
                    </TableCellWithConfig>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Pagination paginationProps={paginationProps}/>
        </PortletContent>
      </Portlet>
    </TextPlaceholderWrapper>
  );
}


SpecialDeliveryDaysTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  deleteSpecialDeliveryDay: PropTypes.func.isRequired,
  displayMode: PropTypes.oneOf(Object.values(displayModes)).isRequired,
  specialDeliveryDays: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

SpecialDeliveryDaysTable.defaultProps = {
  BoxTypes: [],
};


export default compose(withStyles(styles), withTranslation())(SpecialDeliveryDaysTable);
